/**
 * The single source of truth for the Monitoring route pattern.
 *
 * It lives in its own module, importing nothing, because the two files that
 * need it import each other: monitoringRoleManagement renders MonitoringTabs,
 * and MonitoringTabs looks its access entry up by route. Exporting the constant
 * from either one would close that cycle and leave it possibly undefined at
 * evaluation time.
 *
 * The pattern was previously written out in both files. Adding a tab updated
 * only one, so the `.find()` matching on it returned undefined, optional
 * chaining swallowed the miss, and every Monitoring tab disappeared for every
 * role — the new one and the five that already worked.
 */
export const MONITORING_ROUTE =
  '/monitoring/(requests|reserves|update|push|allocate-mismatch|inventory-health|payment-follow-ups)'
